<app-widget-asset-preview
    [asset]="getAsset(key)"
    (selectFiles)="onFilesSelected($event)"
    [editable]="true"
    [rounded]="field.props?.rounded || false"
/>
